import {
  BOOK_TIME_ERROR,
  GET_ALL_BOOKED_LESSONS_SUCCESS,
  GET_ALL_BOOKED_LESSONS_ERROR,
  GET_BOOKED_LESSON_SUCCESS,
  GET_BOOKED_LESSON_ERROR,
  CONFIRM_BOOKED_LESSON_SUCCESS,
  CONFIRM_BOOKED_LESSON_ERROR,
  CANCEL_BOOKED_LESSON_SUCCESS,
  CANCEL_BOOKED_LESSON_ERROR,
  CANCEL_BOOKED_LESSON_SUCCESS_TEACHER,
  CANCEL_BOOKED_LESSON_ERROR_TEACHER,
  GET_BOOKED_LESSONS_OF_A_TEACHER_ERROR,
  GET_BOOKED_LESSONS_OF_A_TEACHER_SUCCESS,
  BOOK_TIME_SUCCESS,
  SYNC_ORDER_SUCCESS,
  SYNC_ORDER_ERROR,
  CONFIRM_ORDER_SUCCEEDED_SUCCESS,
  CONFIRM_ORDER_SUCCEEDED_FAIL,
  DELETE_BOOKED_LESSON_BY_ADMIN_SUCCESS,
  DELETE_BOOKED_LESSON_BY_ADMIN_ERROR,
  UPDATE_PAID_FOR_TEACHER_STATUS_SUCCESS,
  UPDATE_PAID_FOR_TEACHER_STATUS_ERROR,
  CREATE_COMPLAINT_SUCCESS,
  CREATE_COMPLAINT_ERROR,
  ADD_REVIEW,
  REVIEW_ERROR
} from '../actions/types'

const initialState = {
  bookedLessons: [],
  bookedTime: [],
  loading: true,
  error: null,
  bookedLesson: {},
}

export default function (state = initialState, action) {
  const { type, payload } = action

  switch (type) {
    case BOOK_TIME_ERROR:
      return {
        ...state,
        loading: false,
        error: payload,
      }
    case SYNC_ORDER_ERROR:
      return {
        ...state,
        loading: false,
        bookedLesson: {},
        error: payload,
      }
    case BOOK_TIME_SUCCESS:
      return {
        ...state,
        bookedLessons: [...state.bookedLessons, payload.bookedTimeData],
        loading: false,
      }
    case SYNC_ORDER_SUCCESS:
      return {
        ...state,
        loading: false,
        bookedLessons: [...state.bookedLessons, payload.bookedLesson],
        bookedLesson: payload.bookedLesson,
      }
    case GET_ALL_BOOKED_LESSONS_SUCCESS:
    case GET_BOOKED_LESSONS_OF_A_TEACHER_SUCCESS:
      return {
        ...state,
        loading: false,
        bookedLessons: payload,
      }
    case GET_ALL_BOOKED_LESSONS_ERROR:
      return {
        ...state,
        loading: false,
        bookedLessons: [],
        error: payload,
      }
    case GET_BOOKED_LESSON_SUCCESS:
    case UPDATE_PAID_FOR_TEACHER_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        bookedLesson: payload,
      }
    case CONFIRM_BOOKED_LESSON_SUCCESS:
      return {
        ...state,
        loading: false,
        bookedLesson: payload,
        bookedLessons: state.bookedLessons.map((lesson) =>
          lesson._id === payload._id
            ? { ...lesson, isConfirmed: payload.isConfirmed }
            : lesson
        ),
      }
    case ADD_REVIEW:
      return {
        ...state,
        loading: false,
        bookedLesson: payload.order,
        bookedLessons: state.bookedLessons.map(lesson => lesson._id === payload.order._id ? { ...lesson, isReviewed: payload.order.isReviewed } : lesson)
      }
    case CANCEL_BOOKED_LESSON_SUCCESS:
    case CANCEL_BOOKED_LESSON_SUCCESS_TEACHER:
      return {
        ...state,
        loading: false,
        bookedLessons: state.bookedLessons.map(bookedLesson => bookedLesson._id === payload._id ? { ...bookedLesson, isCanceledByTeacher: payload.isCanceledByTeacher, state: payload.state } : bookedLesson),
        bookedLesson: payload
      }
    case CONFIRM_ORDER_SUCCEEDED_SUCCESS:
      return {
        ...state,
        loading: false,
        bookedLesson: payload,
        bookedLessons: state.bookedLessons.map((lesson) =>
          lesson._id === payload._id
            ? { ...lesson, isSucceeded: payload.isSucceeded, state: payload.state }
            : lesson
        ),
      }
    case CREATE_COMPLAINT_SUCCESS:
      return {
        ...state,
        loading: false,
        bookedLesson: payload,
        bookedLessons: state.bookedLessons.map((lesson) =>
          lesson._id === payload._id
            ? { ...lesson, isComplained: payload.isComplained, complaint: payload.complaint, state: payload.state }
            : lesson
        ),
      }
    case DELETE_BOOKED_LESSON_BY_ADMIN_SUCCESS:
      return {
        ...state,
        loading: false,
        bookedLessons: state.bookedLessons.filter(bookedLesson => bookedLesson._id !== payload)
      }
    case GET_BOOKED_LESSON_ERROR:
    case CONFIRM_BOOKED_LESSON_ERROR:
    case CANCEL_BOOKED_LESSON_ERROR:
    case CANCEL_BOOKED_LESSON_ERROR_TEACHER:
    case GET_BOOKED_LESSONS_OF_A_TEACHER_ERROR:
    case CONFIRM_ORDER_SUCCEEDED_FAIL:
    case DELETE_BOOKED_LESSON_BY_ADMIN_ERROR:
    case UPDATE_PAID_FOR_TEACHER_STATUS_ERROR:
    case CREATE_COMPLAINT_ERROR:
    case REVIEW_ERROR:
      return {
        ...state,
        loading: false,
        error: payload,
        bookedLesson: {},
      }

    default:
      return state
  }
}
